'use es6';

import { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for providing property source information when requesting property updates
 *
 * @param {object} value                    the context value
 * @param {String} value.propertySource     the source application the changes are coming from
 * @param {String} value.propertySourceId   the source of the change itself, defaults on BE to userId:<theUserId>
 */

export const SidebarPropertySourceContext = /*#__PURE__*/createContext(null);
SidebarPropertySourceContext.Provider.propTypes = {
  value: PropTypes.shape({
    propertySource: PropTypes.string.isRequired,
    propertySourceId: PropTypes.string
  }).isRequired
};